import { render, staticRenderFns } from "./Approveok.vue?vue&type=template&id=7e1abf87&"
import script from "./Approveok.vue?vue&type=script&lang=js&"
export * from "./Approveok.vue?vue&type=script&lang=js&"
import style0 from "./Approveok.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports